var _defs, _rect, _rect2, _rect3, _g, _g2, _rect4, _text, _rect5, _text2, _text3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOutdoorUnit3(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 900 900",
    width: 900,
    height: 900,
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "steel",
    x1: 0,
    y1: 0,
    x2: 0.6,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eef2f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#c6cfd6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93a0a9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "steelDark",
    x1: 0,
    y1: 0,
    x2: 0.6,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6d7982"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#4a545c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2c333a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "graphite",
    x1: 0,
    y1: 0,
    x2: 0.4,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3f4a41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a201b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "green",
    x1: 0,
    y1: 0,
    x2: 0.5,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8BAE66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4b6630"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "copper",
    x1: 0,
    y1: 0,
    x2: 0.7,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f6c79b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#d9853f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96501a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "copperEdge",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b06428"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#f3c295"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8d4a16"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brass",
    x1: 0,
    y1: 0,
    x2: 0.6,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f0dfa4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#c8a83c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8d7420"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "glass",
    x1: 0,
    y1: 0,
    x2: 0.3,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffffff",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff",
    stopOpacity: 0.12
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lcd",
    x1: 0,
    y1: 0,
    x2: 0.3,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cfe6c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8fb37c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "shellWhite",
    x1: 0,
    y1: 0,
    x2: 0.4,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#eef1f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ccd4d9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 0,
    y1: 0,
    x2: 0.3,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbfdfa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9efe6"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "grid",
    width: 36,
    height: 36,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 36 0 L 0 0 0 36",
    fill: "none",
    stroke: "#628141",
    strokeOpacity: 0.13,
    strokeWidth: 1.4
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 900,
    height: 900,
    fill: "url(#bg)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 900,
    height: 900,
    fill: "url(#grid)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 42,
    width: 816,
    height: 816,
    fill: "none",
    stroke: "#628141",
    strokeOpacity: 0.35,
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(450 460) scale(0.76)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -250,
    y: -140,
    width: 500,
    height: 290,
    rx: 26,
    fill: "url(#shellWhite)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -250,
    y: -140,
    width: 500,
    height: 60,
    rx: 26,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -250,
    y: -96,
    width: 500,
    height: 16,
    fill: "#e3e9ec"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -58,
    cy: 10,
    r: 152,
    fill: "#2b332c"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -58,
    cy: 10,
    r: 140,
    fill: "#39423a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -58,
    cy: 10,
    r: 34,
    fill: "none",
    stroke: "#8a949a",
    strokeWidth: 7,
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -58,
    cy: 10,
    r: 60,
    fill: "none",
    stroke: "#8a949a",
    strokeWidth: 7,
    opacity: 0.77
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -58,
    cy: 10,
    r: 86,
    fill: "none",
    stroke: "#8a949a",
    strokeWidth: 7,
    opacity: 0.69
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -58,
    cy: 10,
    r: 112,
    fill: "none",
    stroke: "#8a949a",
    strokeWidth: 7,
    opacity: 0.61
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -58,
    cy: 10,
    r: 138,
    fill: "none",
    stroke: "#8a949a",
    strokeWidth: 7,
    opacity: 0.53
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -58,
    cy: 10,
    r: 34,
    fill: "#20261f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-58,10 q60,-40 96,10 q-56,26 -96,-10",
    fill: "#4a5548",
    transform: "rotate(0 -58 10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-58,10 q60,-40 96,10 q-56,26 -96,-10",
    fill: "#4a5548",
    transform: "rotate(120 -58 10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-58,10 q60,-40 96,10 q-56,26 -96,-10",
    fill: "#4a5548",
    transform: "rotate(240 -58 10)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: -96,
    width: 120,
    height: 210,
    rx: 10,
    fill: "#39423a"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: -84,
    width: 100,
    height: 10,
    rx: 5,
    fill: "#8a949a",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: -62,
    width: 100,
    height: 10,
    rx: 5,
    fill: "#8a949a",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: -40,
    width: 100,
    height: 10,
    rx: 5,
    fill: "#8a949a",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: -18,
    width: 100,
    height: 10,
    rx: 5,
    fill: "#8a949a",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 4,
    width: 100,
    height: 10,
    rx: 5,
    fill: "#8a949a",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 26,
    width: 100,
    height: 10,
    rx: 5,
    fill: "#8a949a",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 48,
    width: 100,
    height: 10,
    rx: 5,
    fill: "#8a949a",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 70,
    width: 100,
    height: 10,
    rx: 5,
    fill: "#8a949a",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 92,
    width: 100,
    height: 10,
    rx: 5,
    fill: "#8a949a",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("text", {
    x: 178,
    y: 140,
    fontFamily: "'Arial Narrow', 'Helvetica Neue', Arial, sans-serif",
    fontSize: 24,
    fontWeight: 700,
    fill: "#628141",
    fillOpacity: 1,
    textAnchor: "middle",
    letterSpacing: 3.84
  }, "TECNIQA"), /*#__PURE__*/React.createElement("rect", {
    x: -236,
    y: 150,
    width: 120,
    height: 30,
    rx: 10,
    fill: "#39423a"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 150,
    width: 120,
    height: 30,
    rx: 10,
    fill: "#39423a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-250,86 C-300,86 -310,120 -300,150",
    fill: "none",
    stroke: "url(#copperEdge)",
    strokeWidth: 18,
    strokeLinecap: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    stroke: "#628141",
    strokeWidth: 2,
    strokeOpacity: 0.7,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170 732 h560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170 722 v20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M730 722 v20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768 220 v420"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M758 220 h20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M758 640 h20"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 380,
    y: 716,
    width: 140,
    height: 32,
    rx: 6,
    fill: "#fbfdfa"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 450,
    y: 739,
    fontFamily: "'Arial Narrow', 'Helvetica Neue', Arial, sans-serif",
    fontSize: 20,
    fontWeight: 700,
    fill: "#628141",
    fillOpacity: 1,
    textAnchor: "middle",
    letterSpacing: 1.6
  }, "1.0\u20132.0 TR")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 42,
    width: 112,
    height: 40,
    fill: "#1B211A"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 62,
    y: 69,
    fontFamily: "'Arial Narrow', 'Helvetica Neue', Arial, sans-serif",
    fontSize: 19,
    fontWeight: 700,
    fill: "#ffffff",
    fillOpacity: 1,
    textAnchor: "start",
    letterSpacing: 2.28
  }, "Voltas")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 854,
    fontFamily: "'Arial Narrow', 'Helvetica Neue', Arial, sans-serif",
    fontSize: 24,
    fontWeight: 700,
    fill: "#1B211A",
    fillOpacity: 0.5,
    textAnchor: "start",
    letterSpacing: 0.96
  }, "Split AC Outdoor Unit \u2014 TECHNICAL VIEW")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutdoorUnit3);
export default __webpack_public_path__ + "static/media/outdoor-unit-3.8f7ed2f35bdeb7e76f9783f5c91d59cc.svg";
export { ForwardRef as ReactComponent };